export const environment = {
  production: true,
  apiUrl: 'https://api.stratcare.co.uk',
  appID: 'stratcare_2-zpierhn',
  assessmentsCollection: 'assessments_staging',
  auth0Audience: 'https://mindlife-stratcare.uk.auth0.com/api/v2/',
  auth0ClientId: 'qDaFK8dABC2MD4bBNMA5zb8SsoyMGoCn',
  auth0Domain: 'mindlife-stratcare.uk.auth0.com',
  auth0RedirectUri:
    typeof window !== 'undefined'
      ? window.location.origin + '/callback'
      : 'https://stratcare-2-admin-staging.web.app/callback',
  auth0Scope: 'openid profile email',
  consentRefusalCollection: 'consent_refusal_staging',
  databaseName: 'stratcare_2',
  enrollmentFunction: 'ENROLL_NEW_THERAPIST',
  ineligibleAssessmentCollection: 'ineligible_assessments_staging',
  profilesCollection: 'profiles',
  responseLogCollection: 'response_log_staging',
};
